import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import {
  MID,
  NOT_WIDE,
  TINY,
  marketingPalette,
} from "@/components/marketing/tokens";
import { InlineSvg } from "@/components/marketing/Marquee";
import { RELIABLE } from "./homeContent";
import { BODY_SMALL, HEADING_2 } from "./homeType";

/** The first of the four blocks inside the Why Webshare section. */
export default function WhyReliable() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "32px",
        [MID]: { gap: "24px" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
          width: 1,
          maxWidth: "37rem",
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            mb: "4px",
            p: "6.08px 12px",
            // The published rule is `100vw`, which computes to the literal
            // viewport width and reads as a different value at every step.
            borderRadius: "9999px",
            backgroundColor: marketingPalette.labelChip,
            color: marketingPalette.ink,
            fontSize: "0.94rem",
            WebkitTextStrokeWidth: "0.6px",
            [TINY]: { borderRadius: "1rem", px: "0.5rem", fontSize: "0.8rem" },
          }}
        >
          <InlineSvg viewBox="0 0 18 18" size={18}>
            <path
              d="M2.25 5.25L6.75 3L11.25 5.25L15.75 3V12.75L11.25 15L6.75 12.75L2.25 15V5.25Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.75 3V12.75"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.25 5.25V15"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </InlineSvg>
          {RELIABLE.chip}
        </Box>
        <Typography component="h2" sx={HEADING_2}>
          {RELIABLE.heading}
        </Typography>
        <Typography component="p" sx={BODY_SMALL}>
          {RELIABLE.body}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "3.5rem",
          width: 1,
          maxWidth: "72rem",
          p: "2.5rem 2rem",
          borderRadius: "1.5rem",
          backgroundColor: "rgba(7, 66, 39, 0.08)",
          [MID]: {
            flexDirection: "column",
            gap: "1rem",
            p: "1rem",
            borderRadius: "1rem",
          },
        }}
      >
        {RELIABLE.stats.map((stat) => (
          <Box
            key={stat.label}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "4px",
              width: 1,
              [TINY]: { gap: "6.4px" },
            }}
          >
            <Box
              sx={{
                color: marketingPalette.statInk,
                fontSize: "4.75rem",
                lineHeight: "90%",
                WebkitTextStrokeWidth: "1px",
                [NOT_WIDE]: { fontSize: "4rem" },
                [MID]: { fontSize: "3rem" },
              }}
            >
              {stat.value}
            </Box>
            <Box
              sx={{
                color: marketingPalette.ink,
                fontSize: 19,
                lineHeight: "28.5px",
                [NOT_WIDE]: { fontSize: 17, lineHeight: "25.5px" },
                [MID]: { fontSize: 15, lineHeight: "22.5px" },
              }}
            >
              {stat.label}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
